<template>
<div class="chapter">
<div class="inner_page">
<p class="part-num">Part I</p>
<p class="part-hd">WHEREVER BUSINESS COULD BE HAD</p>
<div class="image-break">
<p class="image-center"><img alt="img" src="images/Page19.jpg"/></p>
<p class="caption">Crowded sidewalk shoppers waiting for Auerbach’s doors to open. <i>Special Collections, Marriott Library, University of Utah</i>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?041a4b0b